import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { BlockchainService } from "../blockchain.service";

@Component({
  selector: "app-get-all-assets",
  templateUrl: "./get-all-assets.component.html",
  styleUrls: ["./get-all-assets.component.scss"],
})
export class GetAllAssetsComponent implements OnInit {
  response: any[] = [];
  constructor(private _snackBar: MatSnackBar, private blockchainService: BlockchainService, private router: Router) {}

  ngOnInit() {
    this.getAllAssets();
  }

  async getAllAssets() {
    this.response = [];
    this.blockchainService.getAllAssets().subscribe((data) => {
      if (data == null) {
        this._snackBar.open("No data found", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3000,
        });
        return;
      }

      console.log(data);
      this.response = data.records;
      console.log(this.response);
    });
  }

  searchAssetById(value: any) {
    console.log(value);
    localStorage.setItem("blockchainSelectedAssetId", value.id);
    this.router.navigate(["/secure/blockchain/get-asset-by-id"]);
  }
}
